// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__yX_at","noInteraction":"EventWrapper_noInteraction__C6ZyX"};